import React from 'react';
import Dialog, { DialogBody, DialogCloseButton } from '@/ui/dialogs/Dialog';
import PopupNg from '@/ui/PopupNg';
import UserMessage from './AccountMessage';

const AccountMessageDialog = ({ data }) => (
    <Dialog>
        <DialogCloseButton onClose={PopupNg.dispatcher.close} />
        <DialogBody className="user-message-dialog">
            <UserMessage spravaId={data.get('id').toString()} inDialog />
        </DialogBody>
    </Dialog>
);

export default AccountMessageDialog;
